import React from "react";
import { Col, Modal, Row } from "antd";
import "../../../../assets/style/modalStyle/postNews.scss";
import { useDispatch, useSelector } from "react-redux";
import TranslateText from "../../TranslateText";
import imageLogo from "../../../../assets/images/image 9.png";
import "../../../../assets/style/modalStyle/detailNews.scss";
import EditorText from "../../EditorText";
import { useEffect } from "react";
import { useState } from "react";
import InputText from "../../Input/InputText";
import LabelInput from "../../LabelInput";
import { link } from "fs";
import { IconLock } from "../../../../assets/icon";
import moment from "moment";
const ModalShowDetail = ({ width = 930, getData, selector, close }) => {
  const state = useSelector(selector);
  const { isOpenModalDetail, detailByID } = state;
  const [data, setData] = useState({
    content: "",
    title: "",
    time: "",
    type: "",
  });
  useEffect(() => {
    setData({
      content: detailByID.content,
      title: detailByID.title,
      time: detailByID.time ? detailByID.time : detailByID.timeCreate,
      type: detailByID.typePost,
    });
  }, [
    detailByID.content,
    detailByID.time,
    detailByID.timeCreate,
    detailByID.title,
    detailByID.typePost,
  ]);
  const dispatch = useDispatch();
  const handCancel = () => {
    dispatch(close());
  };
  useEffect(() => {
    dispatch(getData());
  }, [dispatch]);
  return (
    <>
      <Modal
        maskClosable={false}
        title={<TranslateText text="Chi tiết bài viết" />}
        centered
        width={width}
        className="modalDetail"
        open={isOpenModalDetail}
        onCancel={handCancel}
        footer={[]}
      >
        {data.content ? (
          <div className="wrapperContentDetail ">
            <div
              className="titleDetail"
              style={{ display: "flex", flexDirection: "column" }}
            >
              <div className="titleContent ">
                <img src={imageLogo} alt="logo" />
                <h1>{data.title}</h1>
              </div>
              <p id="time">
                <IconLock />
                <span> {moment(data.time).format("DD/MM/YYYY")}</span>
              </p>
            </div>
            {data.type === 1 ? (
              <div
                className="contentDetail"
                dangerouslySetInnerHTML={{
                  __html: data.content.replace(
                    new RegExp(window.SERVER_CLIENT_URL, "g"),
                    window.SERVER_URL
                  ),
                }}
              ></div>
            ) : (
              <>
                <Row style={{ margin: "1.5rem 0" }} align="middle">
                  <Col span={2}>
                    <LabelInput text={"Link bài viết"} />
                  </Col>
                  <Col span={16}>
                    <InputText disable text={data.content} />
                  </Col>
                </Row>

                <iframe
                  src={data.content}
                  width="100%"
                  height="400px"
                  title="W3Schools Free Online Web Tutorials"
                  frameborder="0"
                  allowfullscreen
                ></iframe>
              </>
            )}
          </div>
        ) : null}
      </Modal>
    </>
  );
};

export default ModalShowDetail;
